// extracted by mini-css-extract-plugin
export default {"container":"KategoriForm_container__s3Ky1","card":"KategoriForm_card__kdKTv","title":"KategoriForm_title__oLAjn"};